export const selectPageState = state => {
  const pageName = state?.page?.pageName;
  return {
    pageName,
    state: state?.page[pageName],
  };
};
